export function getInternalNotePreview(
  note: string | null | undefined
): string {
  if (!note) return "";

  const maxLength = 20;
  return note.length > maxLength ? `${note.slice(0, maxLength)}...` : note;
}
